export const normalizePlanName = (plan) => String(plan || '').trim().toLowerCase();

export const canAccessAIAgents = (plan) => normalizePlanName(plan) === 'business_test';
